import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";

export type SiteConfigDisplayNameLineProps = {
	/** `sites.label` exposé par `GET /v1/public/site-config` (`display_name`), déjà normalisé. */
	siteDisplayName: string | null;
};

/**
 * Ligne optionnelle sous le titre d’accueil (login notaire, callback DocV, etc.).
 */
export default function SiteConfigDisplayNameLine({ siteDisplayName }: SiteConfigDisplayNameLineProps): React.JSX.Element | null {
	if (siteDisplayName == null || siteDisplayName.length === 0) {
		return null;
	}
	return (
		<Typography typo={ETypo.TEXT_MD_SEMIBOLD} color={ETypoColor.TEXT_PRIMARY}>
			{siteDisplayName}
		</Typography>
	);
}
